import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as userActions from "../../actions/userActions";
import * as departmentActions from "../../actions/departmentActions";
import * as roleActions from "../../actions/roleActions";
import * as serviceActions from "../../actions/serviceActions";
import * as taskActions from "../../actions/taskActions";
import * as modalActions from "../../actions/modalActions";
import * as taxCodeActions from "../../actions/taxCodeActions";

import ServiceForm from "./ServiceForm";
import HeaderWrapper from "../common/HeaderWrapper";

const ServiceEditPage = ({
  users,
  roles,
  departments,
  match,
  actions,
  service,
  history,
  services,
  tasks,
  savingService,
  taxCodes
}) => {
  useEffect(() => {
    if (match.params.id && service && !service.id)
      actions.getService(match.params.id);
  }, [match.params.id, actions, service]);

  useEffect(() => {
    if (!roles.length) actions.loadRoles();
  }, [actions, roles]);

  useEffect(() => {
    if (!departments.length) actions.loadDepartments();
  }, [actions, departments.length]);

  useEffect(() => {
    if (!users.length) actions.loadUsers();
  }, [actions, users.length]);

  useEffect(() => {
    if (!tasks.length) actions.loadTasks();
  }, [actions, tasks.length]);

  useEffect(() => {
    if (!taxCodes.length) {
      actions.loadTaxCodes();
    }
  }, [actions, taxCodes.length]);

  const toggleTask = async (item) => {
    if (item.checked) {
      actions.removeServiceTask(service.id, item.value);
    } else {
      actions.createServiceTask(service.id, item.value);
    }
  };

  const handleSave = async (serviceToUpdate) => {
    await actions.updateService(serviceToUpdate);
  };

  const handleCancel = () => {
    history.goBack();
  };

  return (
    <React.Fragment>
      <HeaderWrapper breadcrumbs={[{ label: "Edit Service" }]} />
      <div className="content-wrapper">
        <ServiceForm
          service={service}
          services={services}
          departments={departments}
          onSave={handleSave}
          onCancel={handleCancel}
          saving={savingService}
          allTasks={tasks.filter((task) => task.status)}
          toggleTask={toggleTask}
          taxCodes={taxCodes}
        />
      </div>
    </React.Fragment>
  );
};

ServiceEditPage.propTypes = {
  actions: PropTypes.object.isRequired,
  users: PropTypes.array,
  departments: PropTypes.array,
  roles: PropTypes.array,
  match: PropTypes.object,
  service: PropTypes.object,
  services: PropTypes.array,
  history: PropTypes.object,
  tasks: PropTypes.array,
  savingService: PropTypes.bool,
  taxCodes: PropTypes.array
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    users: state.reducers.users,
    departments: state.reducers.departments,
    roles: state.reducers.roles,
    tasks: state.reducers.tasks,
    service: state.reducers.service,
    savingService: state.reducers.savingService,
    services: state.reducers.services,
    taxCodes: state.reducers.taxCodes
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...userActions,
        ...departmentActions,
        ...roleActions,
        ...serviceActions,
        ...modalActions,
        ...taskActions,
        ...taxCodeActions
      },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(ServiceEditPage);
